import type { FindHyperguestHotelsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useHyperguestMatched = (input: FindHyperguestHotelsInput) =>
  trpc.hyperguestHotels.findMatched.useQuery(input, {
    placeholderData: keepPreviousData,
  });
